import { ConfirmationDialogService } from './../../../confirmation-dialog/confirmation-dialog.service';
import { Router } from '@angular/router';
import { MatterService } from './../../matter.service';
import { URLUtils } from './../../../urlUtils';
import { HttpService } from '../../../services/http.service';
import { Component, Input, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { environment } from 'src/environments/environment';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalService } from 'src/app/model/model.service';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { ensureActiveSubscription } from 'src/app/shared/subscription-dialog';
import { ConfirmDialogComponent } from 'src/app/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmPlanComponent } from 'src/app/confirm-plan/confirm-plan.component';

@Component({
    selector: 'app-viewlegalmatter',
    templateUrl: './viewlegalmatter.component.html',
    styleUrls: ['./viewlegalmatter.component.scss'],
    standalone: false
})
export class ViewlegalmatterComponent implements OnInit {
  @Input() data: any;
  @BlockUI()
  blockUI!: NgBlockUI;
  legalMatters: any = [];
  isDesc: boolean = false;
  searchText: any = '';
  pipe = new DatePipe('en-US');
  hoveredGroups: any;
  product = environment.product;
  value: any = 1;
  options: any = [
    { name: "Internal Matters", value: 1 }, 
    { name: "External Matters", value: 2 }
  ];
  selectedOption: any;

  itemsPerPage: number = 10; // Initialize with the number of items per page
  currentPage: number = 1;
  //matterCount:any;
  role: any;
  updateLM:any;
  successModel: boolean = false;
  successGrpName: string = "";
  relNextCursor:any;
  relPrevCursor:any;  
  searchTermChanged = new Subject<string>();
  selectedMatter: string = "legalmatter";

  showSubscriptionPopup = false;
  getPlan:any;
  getCategory:any;
  restrictedPlans = ['free', 'professional', 'starter'];

  constructor(private httpservice: HttpService, private http: HttpClient, private matterService: MatterService, 
    private router: Router, private toast: ToastrService,private modalService: ModalService,private dialog: MatDialog,
    private confirmationDialogService: ConfirmationDialogService,private spinnerService: NgxSpinnerService) { }

  ngOnInit() {
    // if(this.product == 'corporate'){
    //   this.selectedOption = 'External Matters'
    // this.getExternalMatters();
    //}
    // else{
    //   this.selectedOption = 'Internal Matters'
      this.getLegalMatters();
    //}
    var role = localStorage.getItem("role")
    this.role = role;
    this.getPlan = localStorage.getItem("plan"); // get current plan
    this.getCategory = localStorage.getItem("category"); // get current category
    //console.log('getPlan',this.getPlan)

    this.searchTermChanged.pipe(
      debounceTime(500),      // wait 500ms after the last keystroke
      distinctUntilChanged()  // only if the text is different
    ).subscribe(term => {
      //this.currentPage = 1;  // RESET to first page

      if (term.trim()) {
        this.getSearch(term);
      } else {
        //after removing or use search text!!
        if (this.selectedOption == "External Matters")
          this.getExternalMatters();
        else
          this.getLegalMatters();
      }
    });

    localStorage.removeItem('activeMatterSubTab');
    localStorage.removeItem('activeMatterTab');
    localStorage.removeItem('activeMatterTabId');
    localStorage.removeItem('currentMatterId');

  }

  getLegalMatters() {
    this.spinnerService.show();
    let page = { paginate: true };
    this.searchText = '';

    this.httpservice.sendGetRequest(URLUtils.getLegalMatter,page).subscribe((res: any) => {
      this.spinnerService.hide();
      this.legalMatters = res && res["matters"];
      this.relNextCursor = res?.next_cursor;
      this.relPrevCursor = res?.prev_cursor;
      if (res && res["matters"]) {
        this.legalMatters = res["matters"].map((matter: any) => {
          const uniqueMembers = new Map(); // Remove duplicate members
          const members = matter.members || [];
          const groups = matter.groups || [];

          // matter.members.forEach((member: any) => {
          //   if (!uniqueMembers.has(member.id)) {
          //     uniqueMembers.set(member.id, member);
          //   }
          // });
          // matter.members = Array.from(uniqueMembers.values());

          // matter.groups = matter.groups.filter((group: any) => 
          //   group.name !== 'AAM' && group.name !== 'SuperUser'
          // );

          members.forEach((member: any) => {
            if (member?.id && !uniqueMembers.has(member.id)) {
              uniqueMembers.set(member.id, member);
            }
          });
          matter.members = Array.from(uniqueMembers.values());
          matter.groups = groups.filter((group: any) =>
            group?.name !== 'AAM' && group?.name !== 'SuperUser'
          );


          return matter;
        });
        //console.log('Filtered legalMatters:', this.legalMatters);
      }
      //this.matterCount = this.legalMatters.length;
      //console.log('this.legalMatters',this.legalMatters)
    },
      (error: HttpErrorResponse) => {
        this.spinnerService.hide();
        if (error.status === 401 || error.status === 403) {
          const errorMessage = error.error.msg || 'Unauthorized';
          this.toast.error(errorMessage);
          //console.log(error);
        }
      })
  }

  getExternalMatters() {
    this.spinnerService.show();
    let page = { paginate: true };
    this.searchText = '';

    this.httpservice.sendGetRequest(URLUtils.getLegalExternalMatter,page).subscribe((res: any) => {
      this.spinnerService.hide();
      this.legalMatters = res && res["matters"];
      this.relNextCursor = res?.next_cursor;
      this.relPrevCursor = res?.prev_cursor;
      //this.matterCount = this.legalMatters.length;
    })
  }

  next() {
    if (!this.relNextCursor) {
     // console.log('N-No next page available');
      return;
    }

    //const after = { after: this.relNextCursor, paginate: true };
    let after: any = { after: this.relNextCursor, paginate: true };
    if (this.searchText && this.searchText.trim()) {
      after.search = this.searchText.trim();
    }
    this.spinnerService.show();

    if (this.selectedOption == "External Matters") {
      this.httpservice.sendGetRequest(URLUtils.getLegalExternalMatter, after).subscribe((res: any) => {
        this.spinnerService.hide()
        this.legalMatters = res && res["matters"];
        this.relNextCursor = res?.next_cursor;
        this.relPrevCursor = res?.prev_cursor;
        //this.matterCount = this.legalMatters.length;
      })
    }
    else {
      this.httpservice.sendGetRequest(URLUtils.getLegalMatter, after).subscribe((res: any) => {
        this.spinnerService.hide();
        this.legalMatters = res && res["matters"];
        this.relNextCursor = res?.next_cursor;
        this.relPrevCursor = res?.prev_cursor || res?.previous_cursor; // handle both possible keys

        if (res && res["matters"]) {
          this.legalMatters = res["matters"].map((matter: any) => {
            const uniqueMembers = new Map(); // Remove duplicate members
            matter.members.forEach((member: any) => {
              if (!uniqueMembers.has(member.id)) {
                uniqueMembers.set(member.id, member);
              }
            });
            matter.members = Array.from(uniqueMembers.values());

            matter.groups = matter.groups.filter((group: any) =>
              group.name !== 'AAM' && group.name !== 'SuperUser'
            );
            return matter;
          });
          //console.log('Filtered legalMatters:', this.legalMatters);
        }
        //this.matterCount = this.legalMatters.length;
        //console.log('this.legalMatters',this.legalMatters)
      })
    }

  }

  prev() {
    if (!this.relPrevCursor) {
      //console.log('P-No previous page available');
      return;
    }

    //const before = { before: this.relPrevCursor, paginate: true };
    let before: any = { before: this.relPrevCursor, paginate: true };
    if (this.searchText && this.searchText.trim()) {
      before.search = this.searchText.trim();
    }
    this.spinnerService.show();

    if (this.selectedOption == "External Matters") {
      this.httpservice.sendGetRequest(URLUtils.getLegalExternalMatter, before).subscribe((res: any) => {
        this.spinnerService.hide();
        this.legalMatters = res && res["matters"];
        this.relNextCursor = res?.next_cursor;
        this.relPrevCursor = res?.prev_cursor;
        //this.matterCount = this.legalMatters.length;
      })
    }
    else {
      this.httpservice.sendGetRequest(URLUtils.getLegalMatter, before).subscribe((res: any) => {
        this.spinnerService.hide();
        this.legalMatters = res && res["matters"];
        this.relNextCursor = res?.next_cursor;
        this.relPrevCursor = res?.prev_cursor || res?.previous_cursor;

        if (res && res["matters"]) {
          this.legalMatters = res["matters"].map((matter: any) => {
            const uniqueMembers = new Map(); // Remove duplicate members
            matter.members.forEach((member: any) => {
              if (!uniqueMembers.has(member.id)) {
                uniqueMembers.set(member.id, member);
              }
            });
            matter.members = Array.from(uniqueMembers.values());

            matter.groups = matter.groups.filter((group: any) =>
              group.name !== 'AAM' && group.name !== 'SuperUser'
            );
            return matter;
          });
          //console.log('Filtered legalMatters:', this.legalMatters);
        }
        //this.matterCount = this.legalMatters.length;
        //console.log('this.legalMatters',this.legalMatters)
      })
    }
  }

  getSearch(term: string) {
    const searchParams = { paginate: true, search: term }; // search text

    this.spinnerService.show();
    
    if (this.selectedOption == "External Matters") {
      this.httpservice.sendGetRequest(URLUtils.getLegalExternalMatter, searchParams).subscribe((res: any) => {
        this.spinnerService.hide();
        this.legalMatters = res && res["matters"];
        this.relNextCursor = res?.next_cursor;
        this.relPrevCursor = res?.prev_cursor;
        //this.matterCount = this.legalMatters.length;
      })
    }
    else {
      this.httpservice.sendGetRequest(URLUtils.getLegalMatter, searchParams).subscribe((res: any) => {
        this.spinnerService.hide();
        this.legalMatters = res && res["matters"];
        this.relNextCursor = res?.next_cursor;
        this.relPrevCursor = res?.prev_cursor;
        if (res && res["matters"]) {
          this.legalMatters = res["matters"].map((matter: any) => {
            const uniqueMembers = new Map(); // Remove duplicate members
            matter.members.forEach((member: any) => {
              if (!uniqueMembers.has(member.id)) {
                uniqueMembers.set(member.id, member);
              }
            });
            matter.members = Array.from(uniqueMembers.values());

            matter.groups = matter.groups.filter((group: any) =>
              group.name !== 'AAM' && group.name !== 'SuperUser'
            );
            return matter;
          });
        }
      })
    }
  }

  onSearchChange(value: string) {
    this.searchTermChanged.next(value);
  }

  onOptionSelect(event: any) {
    this.selectedOption = event.target.value;
    // Perform additional actions based on the selected option
    // For example, you can call a function or update other variables
    //console.log('Selected option:', this.selectedOption);
    // Your additional actions here
    if(this.selectedOption=="External Matters"){
      this.getExternalMatters()

    }else{
      this.getLegalMatters()

    }
  }
  
  getDocuments(id: any) {
    this.httpservice.sendGetRequest(URLUtils.legalHistoryDocuments(id)).subscribe(
      (res: any) => {
        if (res) {
          return res.documents;
        }
      });
    return new Array();
  }
  // sort(property: any) {
  //   this.isDesc = !this.isDesc; //change the direction    
  //   // this.column = property;
  //   let direction = this.isDesc ? 1 : -1;

  //   this.legalMatters.sort(function (a: any, b: any) {
  //     if (a[property] < b[property]) {
  //       return -1 * direction;
  //     }
  //     else if (a[property] > b[property]) {
  //       return 1 * direction;
  //     }
  //     else {
  //       return 0;
  //     }
  //   });
  // };

  // sort(property: string) {
  //   this.isDesc = !this.isDesc;
  //   const direction = this.isDesc ? 1 : -1;

  //   this.legalMatters.sort((a: any, b: any) => {
  //     let aVal = a[property];
  //     let bVal = b[property];

  //     // handle tags separately
  //     if (property === 'tags') {
  //       // turn object of tags into array
  //       const aTags = aVal ? Object.values(aVal) : [];
  //       const bTags = bVal ? Object.values(bVal) : [];
  //       // compare first tag (or empty string if none)
  //       aVal = aTags.length ? aTags[0] : '';
  //       bVal = bTags.length ? bTags[0] : '';
  //     }

  //     // optional: handle groups similarly
  //     if (property === 'groups') {
  //       const aGroups = aVal ? aVal : [];
  //       const bGroups = bVal ? bVal : [];
  //       aVal = aGroups.length ? aGroups[0].name : '';
  //       bVal = bGroups.length ? bGroups[0].name : '';
  //     }

  //     // normal compare
  //     if (aVal < bVal) return -1 * direction;
  //     if (aVal > bVal) return 1 * direction;
  //     return 0;
  //   });
  // }

  sort(property: string) {
    this.isDesc = !this.isDesc;
    const direction = this.isDesc ? 1 : -1;

    this.legalMatters.sort((a: any, b: any) => {
      let aVal = this.resolveProperty(a, property);
      let bVal = this.resolveProperty(b, property);

      // Handle tags (object of tag names)
      if (property === 'tags') {
        const aTags = aVal ? Object.values(aVal) : [];
        const bTags = bVal ? Object.values(bVal) : [];
        aVal = aTags.join(',').toLowerCase();  // combine all tags into string
        bVal = bTags.join(',').toLowerCase();
      }

      // Handle groups (array of objects)
      if (property === 'groups') {
        const aGroups = aVal ? aVal : [];
        const bGroups = bVal ? bVal : [];
        aVal = aGroups.map((g: any) => g.name).join(',').toLowerCase();
        bVal = bGroups.map((g: any) => g.name).join(',').toLowerCase();
      }

      // Clients
      if (property === 'clients') {
        aVal = (aVal || [])
          .map((c: any) => c.name)
          .join(',')
          .toLowerCase();
        bVal = (bVal || [])
          .map((c: any) => c.name)
          .join(',')
          .toLowerCase();
      }

      // Normalize undefined/null
      aVal = aVal || '';
      bVal = bVal || '';

      // Compare case-insensitive
      if (aVal.toString().toLowerCase() < bVal.toString().toLowerCase()) return -1 * direction;
      if (aVal.toString().toLowerCase() > bVal.toString().toLowerCase()) return 1 * direction;
      return 0;
    });
  }

  // Helper to resolve nested properties like "owner.firm_name"
  private resolveProperty(obj: any, path: string): any {
    if (!path) return undefined;
    return path.split('.').reduce((acc, part) => acc && acc[part], obj);
  }
  
  updateGroups(legalMatter: any) {
    this.httpservice.sendGetRequest(URLUtils.getLegalMatterInfoDetails(legalMatter.id)).subscribe((res: any) => {
      const legal = { ...res.matter, groups: legalMatter.groups, id: legalMatter.id };
      this.matterService.editLegalMatter(legal);
    })
    //this.matterService.editLegalMatter(legalMatter);
    this.router.navigate(['/matter/legalmatter/updateGroups'])
  }
    
  updateTms(legalMatter: any) {
    this.httpservice.sendGetRequest(URLUtils.getLegalMatterInfoDetails(legalMatter.id)).subscribe((res: any) => {
      const legal = { ...res.matter, groups: legalMatter.groups, id: legalMatter.id };
      this.matterService.editLegalMatter(legal);
    })
    //this.matterService.editLegalMatter(legalMatter);
    this.router.navigate(['/matter/legalmatter/updateTeams'])
  }

  loadEditMatterInfo(legalMatter: any) {
    // this.matterService.editLegalMatter(legalMatter);
    this.httpservice.sendGetRequest(URLUtils.getLegalMatterInfoDetails(legalMatter.id)).subscribe((res: any) => {
      const legal = { ...res.matter, groups:legalMatter.groups, id:legalMatter.id };
      //console.log('legal for edit:', legal);
      this.matterService.editLegalMatter(legal);
    })
    this.router.navigate(['/matter/legalmatter/edit/'+legalMatter.id])
  }
  loadViewDetails(legalMatter: any,type:any) {
    // const legal = { ...legalMatter, type: type };
    // this.matterService.editLegalMatter(legal);
    localStorage.setItem('mattertype', type);
    localStorage.setItem('currentMatterId', legalMatter.id);
    // viewDetails loads the full matter itself; emit the row so it can render straight away
    this.matterService.editLegalMatter({ ...legalMatter, type: type });
    this.router.navigate(['/matter/legalmatter/viewDetails']);
    //this.router.navigate(['/matter/legalmatter/viewDetails', legalMatter.id])
    
    // if(this.product == 'corporate' && this.selectedOption !='External Matters'){
    // this.router.navigate(['/matter/legalmatter/externalviewDetails'])
    // }
  }
  onMouseOver(grps: any) {
    let newList = [...grps]
    this.hoveredGroups = [];
    //console.log('hoveredGroups',this.hoveredGroups)
    if (grps.length > 2) {
      let sliceArray = newList.splice(2, grps.length);
      this.hoveredGroups = sliceArray.map((item: any, i: number) => item.name);
    }
  }
  updateMatterStatus(legalMatter: any, status: string) {
    //console.log('lm',legalMatter)
    let Documents = this.getDocuments(legalMatter.id);
    let s = status == 'Closed' ? 'close' : 'reopen';
    //let test = s + ' ' + legalMatter.title + ' matter ?';
    let test = s + ' this matter?';
    this.httpservice.sendGetRequest(URLUtils.getLegalMatterInfoDetails(legalMatter.id)).subscribe((res: any) => {
      this.updateLM = { ...res.matter, groups:legalMatter.groups, id:legalMatter.id };
      //console.log('updateLM',this.updateLM)
      this.matterService.editLegalMatter(this.updateLM);
    })

    // this.confirmationDialogService.confirm('Confirmation', 'Are you sure you want to ' + test , true, 'Yes', 'No')
    //   .then((confirmed) => {
    //     if (confirmed) {
    //       let clients = [
    //         ...this.updateLM.clients.map((obj: any) => ({
    //           id: obj.id,
    //           type: obj.type
    //         })),
    //         ...(this.updateLM?.corporate?.length > 0
    //           ? this.updateLM.corporate.map((obj: any) => ({
    //             id: obj.id,
    //             type: obj.type
    //           }))
    //           : [])
    //       ];

    //       let obj = {
    //         "title": this.updateLM.title,
    //         "case_number": this.updateLM.caseNumber,
    //         "date_of_filling": this.pipe.transform(this.updateLM.date_of_filling, 'dd-MM-yyyy'),
    //         "description": this.updateLM.description,
    //         "case_type": this.updateLM.caseType,
    //         "court_name": this.updateLM.courtName,
    //         "judges": this.updateLM.judges,
    //         "priority": this.updateLM.priority,
    //         "status": status,
    //         "affidavit_isfiled": "na",
    //         "affidavit_filing_date": "",
    //         "clients": clients,
    //         "members": this.updateLM.members.map((obj: any) => ({ "id": obj.id })),
    //         //"owner": legalMatter.owner.map((obj: any) => ({ "id": obj.id, "name": obj.name })),
    //         "owner": this.updateLM.owner,
    //         //"tags":this.updateLM.tags,
    //         "tags": this.arrayToObject(this.updateLM.tags),
    //         "documents": this.updateLM.documents?.map((obj: any) => ({
    //           "docid": obj.docid,
    //           "doctype": obj.doctype,
    //           "user_id": obj.user_id
    //         })),
    //         "group_acls": this.updateLM.groupAcls,
    //         "opponent_advocates": this.updateLM.opponentAdvocates
    //       }
    //     //console.log('obj:',obj)
    //     this.httpservice.sendPatchRequest(URLUtils.updateLegalMatter(legalMatter.id), obj).subscribe((res: any) => {
    //       if (!res.error) {
    //         let s = status == 'Closed' ? 'closed' : 'reopened';
    //         //let test = s + ' the ' + legalMatter.title + ' matter.';
    //         let test = s + ' this '  + ' matter.';
  
    //         this.successModel = true;
    //         this.successGrpName = test;
    //         this.getLegalMatters();

    //         // this.confirmationDialogService.confirm('Success', 'Congratulations! You have successfully ' + test, false, 'View Matter List', 'Cancel', true)
    //         //   .then((confirmed) => {
    //         //     if (confirmed) {
    //         //       this.getLegalMatters();
    //         //     }
    //         //   })
    //       }
    //     },
    //     (error: HttpErrorResponse) => {
    //       if (error.status === 401 || error.status === 403) {
    //         const errorMessage = error.error.msg || 'Unauthorized';
    //         this.toast.error(errorMessage);
    //         console.log(error);
    //       }
    //     }
    //     );
    //   }
    // })

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: { title: 'Confirmation', message: `Are you sure you want to ${test}` }
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      //console.log('Dialog result:', result);
      if (result) {

        let clients = [
          ...this.updateLM.clients.map((obj: any) => ({
            id: obj.id,
            type: obj.type
          })),
          ...(this.updateLM?.corporate?.length > 0
            ? this.updateLM.corporate.map((obj: any) => ({
              id: obj.id,
              type: obj.type
            }))
            : [])
        ];

        let obj = {
          "title": this.updateLM.title,
          "case_number": this.updateLM.caseNumber,
          "date_of_filling": this.pipe.transform(this.updateLM.date_of_filling, 'dd-MM-yyyy'),
          "description": this.updateLM.description,
          "case_type": this.updateLM.caseType,
          "court_name": this.updateLM.courtName,
          "judges": this.updateLM.judges,
          "priority": this.updateLM.priority,
          "status": status,
          "affidavit_isfiled": "na",
          "affidavit_filing_date": "",
          "clients": clients,
          "members": this.updateLM.members.map((obj: any) => ({ "id": obj.id })),
          //"owner": legalMatter.owner.map((obj: any) => ({ "id": obj.id, "name": obj.name })),
          "owner": this.updateLM.owner,
          //"tags":this.updateLM.tags,
          "tags": this.arrayToObject(this.updateLM.tags),
          "documents": this.updateLM.documents?.map((obj: any) => ({
            "docid": obj.docid,
            "doctype": obj.doctype,
            "user_id": obj.user_id
          })),
          "group_acls": this.updateLM.groupAcls,
          "opponent_advocates": this.updateLM.opponentAdvocates
        }
        //console.log('obj:',obj)
        this.httpservice.sendPatchRequest(URLUtils.updateLegalMatter(legalMatter.id), obj).subscribe((res: any) => {
          if (!res.error) {
            let s = status == 'Closed' ? 'closed' : 'reopened';
            let test = s + ' this ' + ' matter.';
            // this.successModel = true;
            // this.successGrpName = test;
            this.toast.success(res.msg || `You have successfully ${test}`);
            this.getLegalMatters();
          }
        },
          (error: HttpErrorResponse) => {
            if (error.status === 401 || error.status === 403) {
              const errorMessage = error.error.msg || 'Unauthorized';
              this.toast.error(errorMessage);
              //console.log(error);
            }
          }
        );

      }
    });

  }

  arrayToObject(tags: any): any {
    if (!tags) return {};
    // if it's already an object, return as is
    if (typeof tags === 'object' && !Array.isArray(tags)) return tags;

    // convert array → object
    const obj: any = {};
    tags.forEach((tag: string, index: number) => {
      obj[index] = tag;
    });
    return obj;
  }


  closeModal(): void {
    this.successModel = false;
  }

  ok() {
    this.getLegalMatters();
  }

  delete (legalMatter: any) {
  this.confirmationDialogService.confirm('Confirmation', legalMatter.title + ' matter contains ' + legalMatter.documents?.length + ' documents. Are you sure do you want to delete this matter?', true, 'Yes', 'No')
    .then((confirmed) => {
      if (confirmed) {
        this.httpservice.sendDeleteRequest(URLUtils.deleteLegalMatter(legalMatter.id)).subscribe((res: any) => {
          //console.log(legalMatter.id + 'ifs deleted');
          if (!res.error) {
            this.confirmationDialogService.confirm('Success', 'Congratulations! You have successfully deleted ' + legalMatter.title, false, 'View Matter List', 'Cancel', true)
              .then((confirmed) => {
                if (confirmed) {
                  this.getLegalMatters();
                }
              })
          }
        },
        (error: HttpErrorResponse) => {
          if (error.status === 401 || error.status === 403) {
            const errorMessage = error.error.msg || 'Unauthorized';
            this.toast.error(errorMessage);
            //console.log(error);
          }
        });
      }
    })
  }
  getTagList(tagsObj: { [key: string]: string }): string[] {
    return Object.values(tagsObj);
  }

  preventLeadingSpace(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    const isFirstChar = input.selectionStart === 0;
    if (event.key === ' ' && isFirstChar) {
      event.preventDefault(); //prevent space at 1st position
    }
  }
    
  isRestrictedPlan(): boolean {
    return this.restrictedPlans.includes((this.getPlan || '').trim().toLowerCase());
  }

  //subscription check for action button
  checkPlan(event?: MouseEvent): boolean {
    const restrictedPlans = ['free', 'professional', 'starter'];

    if (restrictedPlans.includes(this.getPlan)) {

      this.dialog.open(ConfirmPlanComponent, {
        width: '400px',
        data: { plan: this.getPlan }
      });

      return false;   // Stop further execution
    }
    return true;      // Allow further execution
  }

  onClick(value: string) {
    if (!ensureActiveSubscription(this.confirmationDialogService)) { return; }

    // Stop here if plan is restricted
    if (!this.checkPlan()) {
      return;
    }

    this.selectedMatter = value;
    this.selectedMatter=='legalmatter'?this.router.navigate(['/matter/legalmatter/create']):this.router.navigate(['/matter/generalmatter/create']);
    localStorage.removeItem('oncancel');
  }
}

